// import external dependencies

import "jquery"
import AOS from 'aos'

// Import everything from autoload
import "./autoload/_bootstrap.js"
import "./modules/_header"
import "./modules/animations"
import "./modules/gallery"

jQuery(document).ready(() => {
	$('.right-button').click(function () {
		$(this).next().css('transform', 'translateX(0)')
	});

	//aos init
	AOS.init({disable: 'mobile'});

	//Custom Sidebar Position
	function sidebarPosition() {
		const customSidebar = $('.page-sidebar');
		const interiorTitle = $('.interior-title__block');

		if (customSidebar.length) {
			const interiorTitleOffsetLeft = interiorTitle.offset().left - 65;

			if (interiorTitleOffsetLeft > 10) {
				customSidebar.css('margin-right', interiorTitleOffsetLeft + 'px');
			} else {
				customSidebar.css('margin-right', 'auto');
			}
		}
	}

	//Featured Procedures Toggle Class
	function featuredToggleClass() {
		const featuredEl = $('.featured-block');
		const featuredBtn = $('.featured-block a');

		featuredEl.click(function (e) {
			if ($(window).width() < 992) {
				if (!$(e.target).is(featuredBtn)) {
					e.preventDefault();
					$('.featured-items').find('.featured-block.hover').removeClass('hover');
					$(this).toggleClass("hover");
				}
			}
		});

		featuredEl.mouseover(function () {
			if ($(window).width() > 991) {
				$('.featured-items').find('.featured-block.hover').removeClass('hover');
				$(this).toggleClass('hover');
				// console.log('hov');
			}
		});

		featuredEl.mouseout(function () {
			$('.featured-items').find('.featured-block.hover').removeClass('hover');
		});
	}

	function featuredResetClass() {
		const featuredEl = $('.featured-block');

		featuredEl.removeClass('hover');
	}

	$(window).resize(function () {
		sidebarPosition();
		featuredResetClass();
		featuredToggleClass();
	});

	sidebarPosition();
	featuredToggleClass();
});



// WEBPACK FOOTER //
// ./scripts/main.js